import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { OPS_HUB_ROUTE_PATHS } from '../config';

export const FX_CONFIGURATION_ROUTES: TApplicationRoute[] = [
  {
    id: 'ops-hub-fx-configuration',
    path: OPS_HUB_ROUTE_PATHS.fxConfiguration,
    component: lazy(() => import('./pages/fx-configuration-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['fx-configuration'] },
    menu: {
      title: 'FX Configuration',
    },
  },
];
